import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FlowmetersService } from 'src/app/providers/services/flowmeters.service';
import { Flowmeter } from 'src/app/storage/models/flowmeter.model';
import { Mission } from 'src/app/storage/models/mission.model';
import { SkidMission } from 'src/app/storage/models/skid-mission.model';

@Component({
    selector: 'app-add-flowmeter',
    templateUrl: './add-flowmeter.component.html',
    styleUrls: ['./add-flowmeter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddFlowmeterComponent implements OnInit, OnDestroy {

  displayedFlowmeters: Flowmeter[];
  flowmeters: Flowmeter[]

  @Input() mission: Mission;
  @Input() missionSkid: SkidMission;
  @Output() closeModal = new EventEmitter<any>();

  private flowmetersSubscription: Subscription;

  constructor(
    private flowmetersService: FlowmetersService
  ) { }

  ngOnInit(): void {
    this.flowmetersSubscription = this.flowmetersService.flowmeters$.subscribe((flowmeters: Flowmeter[]) => {
      this.flowmeters = flowmeters;
      this.displayedFlowmeters = this.flowmeters;
    });
  }

  ngOnDestroy(): void {
    if (this.flowmetersSubscription) { this.flowmetersSubscription.unsubscribe(); }
  }

  close(): void {
    this.closeModal.emit();
  }

  addFlowmeter(flowmeter: Flowmeter): void {
    this.closeModal.emit(flowmeter);
  }

  filter($event): void {
    const value = $event.target.value;

    this.displayedFlowmeters = this.flowmeters.filter(flowmeter => {
      // List attribute to filter on
      const attributesToFilterOn = [
        flowmeter.flowmeterId,
        flowmeter.flowmeterName,
        flowmeter.flowmetermodelName,
        flowmeter.fieldprotocolName
      ];

      // Find at least one attribute that checks the criterion
      return attributesToFilterOn.find(attribute =>
        attribute.toUpperCase().includes(value.toUpperCase())
      ) != null;
    });
  }

}
